import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { OrderDetailPage } from '@/pages/orders/detail/OrderDetailPage';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

const orderDetailSearchSchema = z.object({
	tab: z.enum(['items', 'uploads', 'messaging', 'activity']).optional().catch(undefined),
	// Set when opened from the member's chain board: the order is assigned to this viewer, so the
	// detail reads the chain member endpoint directly instead of the company-scoped read that 404s.
	chain: z.boolean().optional().catch(undefined),
});

export const Route = createFileRoute('/_authenticated/_app/orders/$orderId')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['orders.read.own', 'orders.read.all'], redirectTo: '/dashboard' }),
	validateSearch: orderDetailSearchSchema,
	component: OrderDetailPage,
});
